import { render } from "./moneyTransferReceived.vue?vue&type=template&id=1d9d6440&ts=true"
import script from "./moneyTransferReceived.vue?vue&type=script&lang=ts"
export * from "./moneyTransferReceived.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\projects\\Auraclub\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__